<div class="At-Wrapper">
    <div class="At-GetStartedSection">
        <div class="At-GetStartInner d-flex  flex-column">
            <div class="At-GetStartedTop">
                <figure>
                    <img src="assets/images/logo-main.png" class="img-fluid" alt="">
                </figure>
                <h1>Komunikasi</h1>
                <h3>The future of comminication<br>
                    via channels and much more ..</h3>
            </div>
            <div class="mt-auto At-GetStartedBottom">
                <a routerLink="/login" class="At-BtnLink"><h4>GET STARTED</h4> </a>
            </div>
        </div>
    </div>
</div>
